// Just return smoothed fps

export default class FPS {
  private range: number;
  private last: number;
  private diffs: number[] = [];

  constructor(range: number) {
    this.range = range;
    this.last = performance.now();
  }

  update(): number {
    const now = performance.now();
    this.diffs.push(now - this.last);
    this.last = now;
    while (this.diffs.length > this.range) {
      this.diffs.shift();
    }
    return this.fps;
  }

  get average(): number {
    const sum = this.diffs.reduce((total, curr) => total + curr, 0);
    return sum / this.diffs.length;
  }

  get fps(): number {
    return 1000.0 / this.average;
  }
}
